export default {
  setNeedDefinePassword(state, needDefinePassword) {
    state.needDefinePassword = needDefinePassword;
  },
};
